<template>
  <Drawer
    title="系统模型设置"
    :visible="visible"
    :before-close="close"
    :loading="loading"
    :size="640"
  >
    <template v-slot:default>
      <el-form :model="formData" label-width="120px" label-position="top" ref="ruleForm">
        <el-form-item
          v-for="(modelItem, modelIndex) in modelTypes"
          :key="modelIndex"
          :label="modelItem + '模型'"
          :prop="modelItem"
        >
          <!-- <el-input placeholder="请输入内容" v-model="formData[modelItem]"></el-input> -->
          <el-select
            v-model="formData[modelItem].defaultName"
            filterable
            placeholder="请选择"
            style="width: 100%"
          >
            <el-option
              v-for="item in groupsType[modelItem]"
              :key="item.model_name"
              :label="item.model_name"
              :value="item.model_name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:footer>
      <el-button class="drawer-footer-btn" type="primary" @click="updateDefaultModel">
        确定
      </el-button>
      <el-button class="drawer-footer-btn" @click="close">取消</el-button>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/drawer';
// import _ from 'lodash';

export default {
  name: 'SandBoxTemplateCreate',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
  },
  data() {
    return {
      formData: {},
      modelTypes: [],
      checked: false,
      showJson: false,
      loading: false,
      modelTypeOptions: [
        {
          label: 'llm',
          value: 'llm',
        },
        {
          label: 'text-embedding',
          value: 'text-embedding',
        },
        {
          label: 'rerank',
          value: 'rerank',
        },
        {
          label: 'speech2text',
          value: 'speech2text',
        },
        {
          label: 'tts',
          value: 'tts',
        },
      ],
      groupsType: {},
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.getList();
        this.getModelTypeOptions();
      }
    },
  },

  methods: {
    // 获取列表数据
    getList() {
      return this.$request({
        url: this.$api.getAiListModel,
        data: {},
      })
        .then((res) => {
          const grouped = res.models.reduce((result, item) => {
            const key = item.model_type;
            if (!result[key]) {
              result[key] = [];
            }
            result[key].push(item);
            return result;
          }, {});
          // grouped
          // this.groupsType
          console.log('%c Line:114 🍒 this.groupsType', 'color:#6ec1c2', grouped);
          this.groupsType = grouped;
        })
        .catch((err) => {
          // err
          console.log('%c Line:261 🍺 err', 'color:#42b983', err);
        });
    },
    // 获取可选项类型有哪些
    getModelTypeOptions() {
      this.loading = true;
      this.modelTypes = [];
      const formData = {};
      this.$request({
        url: this.$api.aiListDefaultModels,
        data: {},
      }).then((res) => {
        const { models } = res;
        for (let i = 0; i < models.length; i++) {
          if (models[i].model_type) {
            formData[models[i].model_type] = {
              ...models[i],
              defaultName: `${models[i].model_name}`,
            };

            this.modelTypes.push(models[i].model_type);
          }
          this.loading = false;
        }
        this.formData = formData;
        console.log('%c Line:88 🥐 this.formData', 'color:#93c0a4', this.formData);
      });
    },
    close() {
      this.$emit('close');
    },
    updateDefaultModel() {
      let updataData = [];
      for (const item of this.modelTypes) {
        updataData.push(
          ...this.groupsType[item].filter((i) => i.model_name === this.formData[item].defaultName),
        );
        updataData = updataData.map((i) => {
          return {
            model_name: i.model_name,
            model_type: i.model_type,
            provider_name: i.provider_name,
          };
        });
      }

      this.$request({
        url: this.$api.aiUpdateDefaultModel,
        data: {
          models: updataData,
        },
      })
        .then((res) => {
          console.log('%c Line:194 🥤 res', 'color:#ed9ec7', res);
          this.$message.success('保存成功');
          this.close();
        })
        .catch((err) => {
          // err
          console.log('%c Line:261 🍺 err', 'color:#42b983', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}

.el-checkbox {
  margin-left: 16px;
  width: 90%;
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
  margin: 16px 0px;
  line-height: 32px;
}
.selectList {
  width: 300px;
}
::v-deep.el-select-dropdown__item {
  width: 600px;
}
</style>
